<template>
    <div class="partner-order">
1
    </div>
</template>
<script>
export default {
  data() {
    return {
      order: {

      },
    };
  },
  mounted() {
    this.fetchOrder();
  },
  methods: {
    fetchOrder() {

    },
  },
};
</script>
